var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonRectangle',{attrs:{"priority":"low-white","size":"small","iconRight":"plusRectangle"},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.level))])
}
var staticRenderFns = []

export { render, staticRenderFns }